<div class="panel panel-default">
    <div class="panel-heading">
        <div class="panel-title">Client Churn (Last 6 Months)</div>
    </div>
    <div class="panel-body">
        <div *ngIf="!isLoaded" class="whirl standard spinnermargin"></div>
        <ng-template [ngIf]="isLoaded">
            <div *ngIf="churnData.length > 0" class="table-responsive">
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>Month</th>
                            <th class="text-right">Created</th>
                            <th class="text-right">Deleted</th>
                            <th class="text-right">Paying Created</th>
                            <th class="text-right">Paying Deleted</th>
                            <th class="text-right">Net</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of churnData">
                            <td>{{ c.month }}</td>
                            <td class="text-right">{{ c.created }}</td>
                            <td class="text-right">{{ c.deleted }}</td>
                            <td class="text-right">{{ c.paying_created }}</td>
                            <td class="text-right">{{ c.paying_deleted }}</td>
                            <td class="text-right" [ngClass]="netClass(c.net)">
                                <strong>{{ c.net }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="churnData.length === 0" class="text-center text-muted py-lg">
                No churn data available.
            </div>
        </ng-template>
    </div>
</div>